import { Handle, Position } from '@xyflow/react'
import { isFired } from './useFiredFlash'
import { selectedBorder } from './selectedBorder.js'
import { nodeControlClass } from '../../lib/nodeControlClass.js'
import { fieldNumber } from '../../lib/fieldNumber.js'

const PRESET_COLORS = ['#ffff00', '#00ff88', '#ff8040', '#80c0ff', '#ff80ff', '#ffffff']

export function PrintNode({ data, selected }) {
  const stop  = e => e.stopPropagation()
  const fired = isFired(data)

  return (
    <div style={{
      background: selected ? '#0f1a2a' : '#091018',
      border: `2px solid ${fired ? '#ffcc44' : selected ? selectedBorder('#1a3060') : '#1a3060'}`,
      boxShadow: fired ? '0 0 14px rgba(255,200,40,0.6)' : 'none',
      borderRadius: 6,
      minWidth: 220,
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      {/* ── Header ── */}
      <div style={{
        background: '#0a2040',
        padding: '7px 14px',
        display: 'flex', alignItems: 'center', gap: 8,
        borderBottom: '1px solid #132840',
        borderRadius: '4px 4px 0 0',
        position: 'relative',
      }}>
        <Handle type="target" position={Position.Left} id="execIn"
          style={{ width: 12, height: 12, background: '#ddd', borderRadius: 2, border: '2px solid #aaa' }} />
        <span style={{ fontSize: 12 }}>ƒ</span>
        <span style={{ color: '#60a0ff', fontWeight: 'bold', fontSize: 11, letterSpacing: 0.5 }}>Print String</span>
        <Handle type="source" position={Position.Right} id="execOut"
          style={{ width: 12, height: 12, background: '#ddd', borderRadius: 2, border: '2px solid #aaa' }} />
      </div>

      {/* ── In String pin ── */}
      <div style={{ padding: '8px 12px 4px', position: 'relative', display: 'flex', alignItems: 'center', gap: 8 }}>
        <Handle
          type="target"
          position={Position.Left}
          id="in-message"
          style={{ background: '#d060e8', width: 10, height: 10, borderRadius: '50%', border: '2px solid #d060e888' }}
        />
        <span style={{ color: '#8040a0', fontSize: 10, minWidth: 54 }}>In String</span>
        <input className={nodeControlClass()}
          type="text"
          value={data.text ?? ''}
          onChange={e => data.onChange?.('text', e.target.value)}
          onMouseDown={stop}
          placeholder="Hello"
          style={{
            flex: 1,
            background: '#040c18', border: '1px solid #142030',
            color: '#d0a0e8', padding: '3px 6px',
            borderRadius: 3, fontSize: 10,
            fontFamily: 'var(--m-mono)', outline: 'none',
          }}
        />
      </div>

      {/* ── Duration + Color ── */}
      <div style={{ padding: '6px 12px 10px', display: 'flex', gap: 8, alignItems: 'flex-end' }}>
        <div style={{ flex: 1 }}>
          <div style={{ color: '#2a4060', fontSize: 9, marginBottom: 3, letterSpacing: 0.5 }}>DURATION (s)</div>
          <input className={nodeControlClass()}
            type="number" min={0.5} max={60} step={0.5}
            value={data.duration ?? 5}
            onChange={e => data.onChange?.('duration', fieldNumber(e.target.value))}
            onMouseDown={stop}
            style={{
              width: '100%', boxSizing: 'border-box',
              background: '#040c18', border: '1px solid #142030',
              color: '#b0cce8', padding: '4px 7px',
              borderRadius: 3, fontSize: 10,
              fontFamily: 'var(--m-mono)', outline: 'none', textAlign: 'right',
            }}
          />
        </div>
        <div>
          <div style={{ color: '#2a4060', fontSize: 9, marginBottom: 3, letterSpacing: 0.5 }}>COLOR</div>
          <div style={{ display: 'flex', gap: 3 }}>
            {PRESET_COLORS.map(c => (
              <div
                key={c}
                // The swatch's colour is the content — nodeLook.css must not clear it.
                className="node-keep-color nodrag"
                title={c}
                onMouseDown={stop}
                onClick={() => data.onChange?.('color', c)}
                style={{
                  width: 14, height: 14, background: c, borderRadius: 2,
                  border: (data.color === c || (!data.color && c === '#ffff00')) ? '2px solid #fff' : '1px solid #222',
                  cursor: 'pointer', flexShrink: 0,
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ── Dev-only stripe ── */}
      <div style={{
        background: 'repeating-linear-gradient(45deg, #1a1500, #1a1500 6px, #0a0a00 6px, #0a0a00 12px)',
        padding: '3px 12px',
        display: 'flex', justifyContent: 'center',
        borderTop: '1px solid #1a1a00',
        borderRadius: '0 0 4px 4px',
      }}>
        <span style={{ color: '#3a3a00', fontSize: 9, letterSpacing: 0.5 }}>Development Only</span>
      </div>
    </div>
  )
}
